import { __decorate } from "tslib";
import { SerializableObject } from '@openhps/core';
import { DepthImageFrame } from './DepthImageFrame';
let DepthVideoFrame = class DepthVideoFrame extends DepthImageFrame {
};
DepthVideoFrame = __decorate([
    SerializableObject()
], DepthVideoFrame);
export { DepthVideoFrame };
//# sourceMappingURL=DepthVideoFrame.js.map